import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import "../../../css/AboutusPage.css";
import axios from "axios";
import { Default } from "../../layouts/default";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import Banner1 from "../../../../src/image/banner-01.jpg";
import Banner2 from "../../../../src/image/banner-02.jpg";
import Banner3 from "../../../../src/image/banner-03.jpg";

const BASE_URL = process.env.REACT_APP_API_ENDPOINT;
const IMG_URL = process.env.REACT_APP_IMG_URL;

const offers = [
  "Online sports venue booking",
  "Cricket ground booking",
  "Football turf booking",
  "Badminton court booking",
  "Pickleball arena booking",
  "Sports facilities near you",
  "Venue management solutions",
  "Easy booking through website and mobile app",
];

function AboutusPage() {
  const facilitySliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024, // jab screen 1024px se chhoti ho
        settings: {
          slidesToShow: 2, // 2 slides dikhaye
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600, // jab screen 600px se chhoti ho
        settings: {
          slidesToShow: 1, // 1 slide dikhaye
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
    ],
  };

  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/get-all-blogs`);
        setBlogs(res.data.blogs || []);
      } catch (err) {
        console.error("Error fetching blogs:", err);
      }
    };
    fetchBlogs();
  }, []);

  const cleanDescription = (desc) => {
    if (typeof desc !== "string") return "";
    return desc.replace(/^"|"$/g, "").replace(/\\"/g, '"');
  };

  const truncateText = (text, maxLength) => {
    if (!text) return "";
    return text.length > maxLength
      ? text.slice(0, maxLength) +
          "<span style={{ color: '#0d6efd' }}>Read more</span>"
      : text;
  };
  return (
    <>
      <Helmet>
        <title>About BookVenue | Sports Venue Booking Platform in India</title>
        <meta
          name="description"
          content="Learn about BookVenue, a trusted platform to book sports venues online, including cricket grounds, football turfs, and courts across India."
        />
      </Helmet>
      <Default>
        <div className="breadcrumb-wrapper">
          <section className="breadcrumb breadcrumb-list mb-0">
            <span className="primary-right-round"></span>
            <div className="container">
              <h1 className="text-white">About Us</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    About Us
                  </li>
                </ol>
              </nav>
            </div>
          </section>
        </div>
        <div className="container">
          <div className="row about-div">
            <h1 className="explore-head">
              About Book Venue - India's Smart Sports Venue Booking Platform
            </h1>
            <p className="text-center text-para">
              Book Venue is a modern sports venue booking platform that helps
              players, teams, fitness enthusiasts, and sports communities easily
              discover and book sports venues online across India.Our platform
              simplifies booking cricket grounds, football turfs, badminton
              courts, pickleball arenas, and other sports facilities through a
              seamless digital experience with real-time availability and easy
              online scheduling.
            </p>
          </div>
        </div>
        <section className="aboutus-info">
          <div className="container">
            <div className="row d-flex align-items-center">
              <div className=" col-12 col-sm-3 col-md-3 col-lg-3">
                <div className="banner text-center">
                  <img
                    src={Banner1}
                    className="img-fluid corner-radius-10"
                    alt="Banner-01"
                  />
                </div>
              </div>
              <div className=" col-12 col-sm-6 col-md-6 col-lg-6">
                <div className="banner text-center">
                  <img
                    src={Banner2}
                    className="img-fluid corner-radius-10"
                    alt="Banner-02"
                  />
                </div>
              </div>
              <div className=" col-12 col-sm-3 col-md-3 col-lg-3">
                <div className="banner text-center">
                  <img
                    src={Banner3}
                    className="img-fluid corner-radius-10"
                    alt="Banner-03"
                  />
                </div>
              </div>
            </div>

            <section className="about-div">
              <h2 className="book-head">Our Mission</h2>

              <p className="text-center text-para">
                At Book Venue, our mission is to make sports venue booking
                simple, fast, and accessible for everyone. We aim to connect
                sports players and venue owners through smart technology that
                improves booking convenience, visibility, and sports community
                engagement.
              </p>

              <div className="offer-section">
                <h2 className="book-head">What We Offer</h2>

                <div className="offer-grid">
                  {offers.map((item, index) => (
                    <div className="offer-card" key={index}>
                      <div className="wave-bg"></div>

                      <div className="card-content">
                        <h3>{item}</h3>

                        <button className="arrow-btn">
                          <span>↗</span>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <h2 className="book-head">Why Choose Book Venue?</h2>

              <p className="text-center text-para">
                Book Venue helps users save time by providing real-time sports
                venue availability, easy booking options, location-based
                searches, secure booking experiences, and simplified sports
                facility management for venue owners.
              </p>
            </section>

            <div className="wrap">
              <div className="inner">
                {/* <!-- INTRO --> */}
                <div className="intro">
                  <h2>
                    Simplifying Sports Venue Booking <span>in Dehradun</span>
                  </h2>
                  <p>
                    BookVenue is a modern sports venue booking platform that
                    makes it easy to find and book grounds and turfs without any
                    hassle.
                  </p>
                  <p>
                    Whether you want to book a cricket ground or book sports
                    venue online, everything is available in one place with
                    real-time availability and instant booking.
                  </p>
                </div>

                {/* <!-- STORY + ABOUT --> */}
                <div className="two-col">
                  <div className="story-card">
                    <div className="section-label">Our Story</div>
                    <h3>How it all started</h3>
                    <div className="story-item">
                      <div className="story-dot"></div>
                      <p>
                        Finding a reliable cricket ground near me for booking
                        was never easy.
                      </p>
                    </div>
                    <div className="story-item">
                      <div className="story-dot"></div>
                      <p>
                        Most people had to call multiple venues and still deal
                        with uncertain availability.
                      </p>
                    </div>
                    <div className="story-item">
                      <div className="story-dot"></div>
                      <p>BookVenue was created to solve this problem.</p>
                    </div>
                    <div className="story-item">
                      <div className="story-dot"></div>
                      <p>
                        We wanted to build a platform where users can quickly
                        find, compare, and book sports venues without wasting
                        time.
                      </p>
                    </div>
                    <div className="story-item">
                      <div className="story-dot"></div>
                      <p>
                        Today, we are helping people in Dehradun book grounds
                        more easily and efficiently.
                      </p>
                    </div>
                  </div>
                  <div className="about-card">
                    <h3>About Us</h3>
                    <p>
                      At BookVenue, our mission is to simplify the way people
                      discover and book sports spaces. As a trusted sports venue
                      booking platform, we help users book sports venues online
                      with ease.
                    </p>
                    <p>
                      From casual games to tournaments, enjoy real-time
                      availability, secure booking, and a seamless experience
                      designed to connect you with quality venues quickly and
                      hassle-free.
                    </p>
                    <div className="about-tags">
                      <span className="about-tag">Cricket</span>
                      <span className="about-tag">Badminton</span>
                      <span className="about-tag">Tennis</span>
                      <span className="about-tag">Football</span>
                    </div>
                    <div className="sports-icons">
                      <span>🏏</span>
                      <span>🏸</span>
                      <span>🎾</span>
                      <span>⚽</span>
                    </div>
                  </div>
                </div>

                {/* <!-- HOW IT WORKS --> */}
                <div className="how-section">
                  <div className="section-label">How BookVenue Works</div>
                  <h3>Getting started is simple</h3>
                  <div className="sub">Four easy steps to your next game</div>
                  <div className="steps-about">
                    <div className="step">
                      <div className="step-circle">1</div>
                      <h4>Sign up</h4>
                      <p>Log in or create your account</p>
                    </div>
                    <div className="step">
                      <div className="step-circle">2</div>
                      <h4>Search</h4>
                      <p>
                        Find sports grounds near you or browse available venues
                      </p>
                    </div>
                    <div className="step">
                      <div className="step-circle">3</div>
                      <h4>Check availability</h4>
                      <p>Choose your preferred venue and time slot</p>
                    </div>
                    <div className="step">
                      <div className="step-circle">4</div>
                      <h4>Book instantly</h4>
                      <p>Confirm your booking in just one click</p>
                    </div>
                  </div>
                </div>

                {/* <!-- WHY CHOOSE --> */}
                <div className="why-section">
                  <div className="section-label">Why Choose BookVenue</div>
                  <h3>Simple, reliable, and fast</h3>
                  <div className="sub">
                    BookVenue is designed to make online turf booking simple and
                    reliable.
                  </div>
                  <div className="why-grid">
                    <div className="why-card">
                      <div className="why-icon">✅</div>
                      <h4>Verified venues</h4>
                      <p>
                        We provide verified venues so you always know what
                        you're booking.
                      </p>
                    </div>
                    <div className="why-card">
                      <div className="why-icon">⚡</div>
                      <h4>Real-time availability</h4>
                      <p>
                        Check live slot availability and book without any
                        back-and-forth.
                      </p>
                    </div>
                    <div className="why-card">
                      <div className="why-icon">🎯</div>
                      <h4>Smooth experience</h4>
                      <p>
                        Book cricket grounds and sports venues quickly without
                        confusion.
                      </p>
                    </div>
                  </div>
                </div>

                {/* <!-- BOOK TODAY --> */}
                <div className="book-section">
                  <div>
                    <div className="section-label">Book Your Venue Today</div>
                    <h3>Your next game starts here</h3>
                    <p>
                      If you are planning a game or event, stop searching
                      endlessly for a cricket ground near you for booking.
                    </p>
                    <p>
                      With BookVenue, you can book sports venues online, explore
                      turf booking options near you, and confirm your slot in
                      just a few clicks.
                    </p>
                    <p>
                      Start your booking in Dehradun today and make your next
                      game hassle-free.
                    </p>
                  </div>
                  <div className="book-visual">
                    <div className="big-icon">🏏</div>
                    <p>Book a venue in under 2 minutes</p>
                  </div>
                </div>

                {/* TAGLINE */}
                <div className="tagline">
                  <p>
                    BookVenue — <span>Find it. Book it. Play it.</span>
                  </p>
                  <div className="sub">
                    Dehradun's trusted sports venue booking platform
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section featured-venues Near-court">
          <div className="container">
            <div
              className="section-heading aos aos-init aos-animate"
              data-aos="fade-up"
            >
              <h2>
                See <span className="blogstyle">Our Blog</span>
              </h2>
            </div>

            <div className="row">
              <div className="col-md-12">
                {blogs && Array.isArray(blogs) && blogs.length > 0 ? (
                  <Slider {...facilitySliderSettings}>
                    {blogs.map((item, index) => {
                      const imgURL = item?.featured_image
                        ? item?.featured_image.replace(/\\\//g, "/")
                        : null;

                      return (
                        <div key={`${item?.official_name}-${index}`}>
                          <div className="featured-slider-group">
                            <Link
                              to={`/blog/${item?.slug}`}
                              className="text-decoration-none"
                            >
                              <div
                                className="featured-venues-item aos aos-init aos-animate"
                                data-aos="fade-up"
                              >
                                <div className="listing-item mb-0">
                                  <div className="listing-img">
                                    <img
                                      src={`${IMG_URL}${imgURL}`}
                                      alt="Venue"
                                      className="img-fluid"
                                    />
                                  </div>

                                  <div className="listing-content">
                                    <h3 className="listing-title-page">
                                      {item?.title}
                                    </h3>

                                    <div className="listing-details-group">
                                      <p
                                        className="listining-para"
                                        style={{ color: "rgb(107, 115, 133)" }}
                                      >
                                        {item.description ? (
                                          <>
                                            {item.description
                                              .replace(/<[^>]+>/g, "")
                                              .slice(0, 110)}
                                            {"... "}
                                            <span style={{ color: "#0d6efd" }}>
                                              Read more
                                            </span>
                                          </>
                                        ) : (
                                          "Read insights on sports venue booking, turf availability, and online booking tips."
                                        )}
                                      </p>
                                    </div>

                                    <div className="listing-button">
                                      <div
                                        className="listing-venue-owner"
                                        style={{ display: "flex" }}
                                      >
                                        {item?.services &&
                                          item?.services.length > 0 &&
                                          item?.services.map((items, idx) => {
                                            const iconURL = items.icon
                                              ? items.icon.replace(/\\\//g, "/")
                                              : null;
                                            return (
                                              <img
                                                key={idx}
                                                src={`${IMG_URL}${iconURL}`}
                                                alt={items?.name}
                                                width="40"
                                                className="me-2"
                                              />
                                            );
                                          })}
                                      </div>

                                      <i
                                        className="bi bi-person-circle me-2"
                                        style={{ fontSize: "1.2rem" }}
                                      ></i>
                                      <span className="me-2">
                                        Written by Admin
                                      </span>
                                      <span>|</span>

                                      <span className="user-book-now">
                                        {new Date(
                                          item?.created_at,
                                        ).toLocaleDateString()}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Link>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div
              className="view-all text-center aos aos-init aos-animate"
              data-aos="fade-up"
            ></div>
          </div>
        </section>
      </Default>
    </>
  );
}

export default AboutusPage;
